(function () {
    'use strict';

    angular
        .module('core.services')
        .service('PreRegistraterService', PreRegistraterService)

    /** @ngInject */
    function PreRegistraterService(HttpService) {
        const PreRegistraterService = {
            getPreRegistration,
            getByParameters,
            createPreRegister,
            resendMail,
            remove,
            registerPerson
        }

        return PreRegistraterService;

        function getPreRegistration(pinCode) {
            return HttpService.get(`/pre-registers/${pinCode}`);
        }

        function getByParameters(params) {
            return HttpService.get('/pre-registers/by-parameters', {
                params
            });
        }

        function createPreRegister(preRegisterData) {
            return HttpService.post('/pre-registers', preRegisterData);
        }

        function resendMail(preRegisterData) {
            return HttpService.put('/pre-registers', preRegisterData);
        }

        function remove(preRegisterId) {
            return HttpService.delete(`/pre-registers/${preRegisterId}`);
        }

        function registerPerson(personData) {
            return HttpService.post('/people/', personData);
        }
    }
}());